import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=1c39dedc&scoped=true&"
import script from "./LeftTree.vue?vue&type=script&lang=ts&"
export * from "./LeftTree.vue?vue&type=script&lang=ts&"
import style0 from "./LeftTree.vue?vue&type=style&index=0&id=1c39dedc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39dedc",
  null
  
)

export default component.exports